// list of valid i18n locale codes: https://github.com/ladjs/i18n-locales#usage

export enum IBMLocale {
  DE = 'de',
  EN = 'en',
  ES = 'es',
  ESLA = 'esla',
  FR = 'fr',
  IT = 'it',
  JA = 'ja',
  KO = 'ko',
  PT = 'pt',
  ZH_CN = 'zh-cn',
}

const availableLangcodes: IBMLocale[] = [
  IBMLocale.DE,
  IBMLocale.EN,
  IBMLocale.ES,
  IBMLocale.ESLA,
  IBMLocale.FR,
  IBMLocale.IT,
  IBMLocale.JA,
  IBMLocale.KO,
  IBMLocale.PT,
  IBMLocale.ZH_CN,
];

const mapValidLocale = (langcode = ''): IBMLocale => {
  // Specific overrides.
  if (langcode === 'zhcn') {
    return IBMLocale.ZH_CN;
  }
  if (langcode === 'zhtw') {
    return IBMLocale.ZH_CN;
  }
  if (langcode === 'esla') {
    return IBMLocale.ES;
  }
  return (
    availableLangcodes.find((candidate) => candidate === langcode) ||
    // Check if there is a match when making the input lower case.
    availableLangcodes.find(
      (candidate) => candidate === langcode.toLowerCase(),
    ) ||
    // Check if there is a match when dropping the locale "fr-ca" becomes "fr".
    availableLangcodes.find(
      (candidate) => candidate === langcode.toLowerCase().replace(/-.*$/, ''),
    ) ||
    IBMLocale.EN
  );
};

export default mapValidLocale;
